import { render, staticRenderFns } from "./10c_doc.vue?vue&type=template&id=7d926fdc&scoped=true"
import script from "./10c_doc.vue?vue&type=script&lang=js"
export * from "./10c_doc.vue?vue&type=script&lang=js"
import style0 from "./10c_doc.vue?vue&type=style&index=0&id=7d926fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d926fdc",
  null
  
)

export default component.exports